import cssVars from "../../styles/vars.module.scss"
import SearchIcon from '@mui/icons-material/Search';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Box, ClickAwayListener, FormControl, IconButton, InputAdornment, OutlinedInput, Popper } from "@mui/material";
import Image from "next/image";
import useTranslation from "../../hooks/useTranslation";
import { CompareListContext } from "../../Providers/CompareListContext";
import { useContext, useRef, useState } from "react";
import CompareSearchRes from "./compareSearchRes";
import animations from "../../styles/animations.module.scss"
import { useTheme } from "@mui/material";

const CompareTableHeader = ({ parentRef }) => {

    const { compareList, removeProductFromCompareList } = useContext(CompareListContext)
    const { t } = useTranslation()

    const [search, setSearch] = useState("")
    const srchRef = useRef()

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'compare-popper' : undefined;

    const remove = (id) => {
        removeProductFromCompareList({
            variables: {
                uid: compareList.uid,
                productID: id
            },
        })
    }
    const w = 484 + (compareList.item_count * 270)
    const theme = useTheme()

    return (
        <Box display="flex" alignItems="center" width={w} className={compareList.item_count && w > parentRef.current?.offsetWidth ? animations.scrollMeRight : ""}>
            <Box p="16px 24px 24px 24px" width={214}>
                <Box fontSize="20px" fontWeight={500}>{t("Compare")}</Box>
                <Box fontSize="14px" sx={{ color: cssVars.darkGray }}>{t("comparing")} ({compareList.item_count} {t("products")})</Box>
            </Box>
            {compareList?.items?.map((item) =>
                <Box p="16px 24px 24px 24px" width={270} key={item.product.canonical_url} borderLeft={`2px solid ${cssVars.extraLightGray}`}>
                    <Box display="flex" alignItems="center" position="relative">
                        <Image width={60} height={60} style={{ objectFit: "contain", objectPosition: "center" }} alt={item.product.name} src={item.product.small_image.url} />
                        <Box className="details" fontSize={14} ml={2}>
                            <Box className="dots1" sx={{ color: theme.palette.primary.main, fontWeight: 500 }}>{item.product.custom_attributes.filter(attr => attr.attribute_metadata.code === "brand")[0]?.selected_attribute_options.attribute_option[0]?.label}</Box>
                            <Box className="dots2" sx={{ mt: 0.5 }} >{item.product.name}</Box>
                        </Box>
                        <CancelOutlinedIcon
                            sx={{
                                fontSize: "16px", position: "absolute", top: "-16px", right: 0,
                                color: cssVars.black, cursor: "pointer", ":hover": { color: cssVars.red }
                            }}
                            onClick={() => { remove(item.product.id) }}
                        />
                    </Box>
                </Box>
            )}
            <Box p="16px 24px 24px 24px" width={270} borderLeft={`2px solid ${cssVars.extraLightGray}`}>
                <ClickAwayListener onClickAway={() => { setAnchorEl(null) }}>
                    <Box>
                        <FormControl ref={srchRef} id="comapreSearch" fullWidth variant="standard" aria-describedby={id} onClick={handleClick}
                            sx={{ "& fieldset, .Mui-focused fieldset": { borderColor: `${cssVars.gray} !important` } }}>
                            <OutlinedInput
                                type="text"
                                sx={{ borderRadius: cssVars.radius }}
                                placeholder={t("Search")}
                                size="small"
                                value={search} onChange={(e) => { setSearch(e.target.value) }}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton edge="end">
                                            <SearchIcon />
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <Popper
                            id={id}
                            open={open}
                            anchorEl={anchorEl}
                            sx={{
                                width: srchRef.current?.offsetWidth + 40,
                                boxShadow: '0px 3px 20px #00000029',
                                zIndex: '4096',
                                background: "#ffffff",
                                borderRadius: cssVars.radius,
                                top: "5px !important"
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <CompareSearchRes search={search} setSearch={setSearch} />
                        </Popper>
                    </Box>
                </ClickAwayListener>

            </Box>
        </Box>
    );
}

export default CompareTableHeader;